export const deeplinkBaseUrl = 'https://fit.teamexos.com';
